import { ToastService } from '@common_services/toast.service';
import { AXIOS_STATUS, AxiosService } from '@umanforge/common';
import { AppStates } from 'App';
import { AxiosError } from 'axios';
import { Dispatch, SetStateAction } from 'react';

export default {

  // Charger dynamiquement le fichier config.json
  getConfig(): Promise<Record<string, unknown>> {
    return fetch( '/config.json' )  // Accède à config.json dans public/
      .then( response => {
        return response.json();
      } )
      .catch( error => {
        console.error( 'Error loading the config.json file', error );
        return {};  // Retourne un objet vide en cas d'erreur
      } );
  },

  async getBackendUrl(): Promise<string> {
    let baseUrl: string = process.env.REACT_APP_API_BASE_URL || '';

    try {
      const config = await this.getConfig();

      if ( config.REACT_APP_API_BASE_URL && config.REACT_APP_API_BASE_URL !== '{{REACT_APP_API_BASE_URL}}' ) {
        baseUrl = String( config.REACT_APP_API_BASE_URL );
      }
    } catch ( error ) {
      console.error( 'Error while retrieving the configuration', error );
    }

    return baseUrl;
  },

  async getPlateformUrl(): Promise<string> {
    let baseUrl: string = process.env.REACT_APP_UMANFORGE_BASE_URL || '';

    try {
      const config = await this.getConfig();

      if ( config.REACT_APP_UMANFORGE_BASE_URL && config.REACT_APP_UMANFORGE_BASE_URL !== '{{REACT_APP_UMANFORGE_BASE_URL}}' ) {
        baseUrl = String( config.REACT_APP_UMANFORGE_BASE_URL );
      }
    } catch ( error ) {
      console.error( 'Error while retrieving the configuration', error );
    }

    return baseUrl;
  },

  isValidEmail( mail: string ): boolean {
    const value = String( mail ?? '' ).trim();
    if ( value.length === 0 || value.length > 320 ) {
      return false;
    }

    const regex = /^(?=.{1,320}$)([A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]{1,64})@((?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)$/;
    if ( !regex.test( value ) ) {
      return false;
    }

    const [ localPart, domainPart ] = value.split( '@' );
    if ( !localPart || !domainPart ) {
      return false;
    }

    if ( localPart.length > 64 || domainPart.length > 255 ) {
      return false;
    }

    const labels = domainPart.split( '.' );
    if ( labels.some( label => {return label.length === 0 || label.length > 63;} ) ) {
      return false;
    }

    return true;
  },

  getRedirectUrl(): string {
    const queryParameters = new URLSearchParams( window.location.search );
    return decodeURI( queryParameters.get( 'redirect_url' ) ?? '' );
  },

  connectUser( token?: string ): void  {
    let url = this.getRedirectUrl();
    if ( url ) {
      if ( token ) {
        url += ( url.includes( '?' ) ? '&' : '?' ) + 'umanforge=' + token;
      }
      window.location.replace( url );
    } else {
      this.getPlateformUrl().then( platformUrl => {
        window.location.replace( platformUrl );
      } );
    }
  },

  onAxiosError( err: AxiosError, toastService: ToastService, setState: Dispatch<SetStateAction<AppStates>> ) {
    setState( AppStates.NeedChangePasswordState );
    if ( err.status === AXIOS_STATUS.FAILURE || err.code === AXIOS_STATUS.ERR_NETWORK ) {
      setState( AppStates.ErrorServer );
    } else {
      toastService.showError( AxiosService.getAxiosMessage( err ) );
    }
  }
};